import React from 'react';
import { Section } from './ui/Section';
export function NotForYou() {
  const points = ['Buscas coreografías de TikTok para copiar sin criterio.', 'Crees que bailar bien es suficiente para enseñar bien.', 'No te importa seguir improvisando el resto de tu carrera.'];
  return <Section variant="alt" data-id="element-205">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title font-display" data-id="element-206">
        ❌ NO ES PARA TI SI...
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-207">
        {points.map((point, i) => <div key={i} className="bg-white border border-red-300 rounded-xl p-6 flex items-start gap-4 shadow-sm" data-id="element-208">
            <span className="text-red-500 text-2xl shrink-0" data-id="element-209">❌</span>
            <p className="text-brand-text font-medium font-body" data-id="element-210">{point}</p>
          </div>)}
      </div>
    </Section>;
}